<ng-container *transloco="let t">
  <ng-container *ngIf="homepageData$ | async as homePageData">
    <raf-section gutterTop="negative">
      <raf-banner-block
        [primary]="homePageData.mainBanner"
        [secondary]="homePageData.secondaryBanners"
      ></raf-banner-block>
    </raf-section>
  </ng-container>

  <ng-container *ngIf="layout$ | async as layout">
    <ng-container *ngIf="promotedProducts$ | async as promotedProducts">
      <raf-loading *ngIf="promotedProductsLoading$ | async" variant="inline"></raf-loading>
      <raf-section *ngIf="promotedProducts.length">
        <raf-products [products]="promotedProducts" [unitPriceVisible]="false" variant="grid"
                      label="HOMEPAGE.PROMOTED_PRODUCTS" (clicked)="onProductSelected($event)"></raf-products>
      </raf-section>
    </ng-container>

    <ng-container *ngIf="promotedCategories$ | async as categories">
      <raf-loading *ngIf="promotedCategoriesLoading$ | async" variant="inline"></raf-loading>
      <raf-section *ngIf="categories.length">
        <raf-catalog-navigation
          [categories]="categories"
          label="HOMEPAGE.CATALOG_NAVIGATION_LABEL"
        ></raf-catalog-navigation>
      </raf-section>
    </ng-container>

    <raf-section>
      <raf-promo-block label="PROMO_BLOCK.LABEL" [content]="layout.shoppingTips"></raf-promo-block>
    </raf-section>

    <raf-section>
      <raf-partners [data]="layout.manufacturerList"></raf-partners>
    </raf-section>
  </ng-container>
</ng-container>
